import React from 'react';
import AlertSet from './AlertSet';
import classNames from 'classnames';
// import PropTypes from 'prop-types';
import { guid } from '../../common/ambient';
import { TIME_ALERT_PARAM, PREVENTATIVE_MAINTENANCE_ALERT_TEMPLATE, REPLACE_BATTERIES_ALERT_TEMPLATE } from './'

export default function CreateAlertSet({ onCreate }) {
  const [selectedTemplate, setSelectedTemplate] = React.useState(null);


  const customTemplate = {
    title: 'Custom Alert Set',
    description: "Create your own custom weather alert sets according your and your group's needs.",
    type: 'custom',
    alerts: []
  };

  const templates = [{
      title: 'Home & Garden',
      description: 'Get alerts for indoor and outdoor environmental conditions of your home, office, yard, or garden.',
      type: 'home',
      alerts: [{
        id: guid(),
        param: "battout",
        condition: "<",
        threshold: 1,
      },{
        id: guid(),
        param: "leak1",
        condition: "=",
        threshold: 1,
      },{
        id: guid(),
        param: "leak1",
        condition: "=",
        threshold: 2,
      },{
        id: guid(),
        param: "pm25_in",
        condition: ">",
        threshold: 55
      },{
        id: guid(),
        param: "weeklyrainin",
        condition: "<",
        threshold: 0.5
      }, {
        id: guid(),
        param: "soilhum1",
        condition: "<",
        threshold: 10
      }]
    }, {
      title: 'Severe Weather',
      description: 'Get alerts for severe outdoor weather conditions for your and your group members safety.',
      type: 'severe',
      alerts: [{
        "id": guid(),
        "param": "feelsLike",
        "condition": ">",
        "threshold": 100,
      }, {
        "id": guid(),
        "param": "hourlyrainin",
        "condition": ">",
        "threshold": 1,
      },{
        "id": guid(),
        "param": "lightning_hour",
        "condition": ">",
        "threshold": 1,
      },{
        "id": guid(),
        "param": "pm25",
        "condition": ">",
        "threshold": 55,
      },{
        "id": guid(),
        "param": "tempf",
        "condition": "<",
        "threshold": 32,
      },{
        "id": guid(),
        "param": "windgustmph",
        "condition": ">",
        "threshold": 25,
      }]
    }, {
      title: 'Maintenance alert sets',
      description: 'Get alerts for sensor cleaning and weather station upkeep needs.',
      type: 'maintenance',
      alerts: [{
        id: guid(),
        param: "battout",
        condition: "<",
        threshold: 1,
      },{
        id: guid(),
        param: "notReporting",
      },{
        id: guid(),
        ...PREVENTATIVE_MAINTENANCE_ALERT_TEMPLATE
      },{
        id: guid(),
        ...REPLACE_BATTERIES_ALERT_TEMPLATE
      }]
    }]
  return (
    <div className="alert-create-alert-set">
      <h3>Create an alert set</h3>
      <p>Select and use a template, customize it or create your own custom alert set</p>
      <div className='templates'>
        {templates.map((template, i) => (
          <div className={classNames('template', { selected: i === selectedTemplate })} key={template.title} onClick={() => {
            setSelectedTemplate(i);
          }}>
            <AlertSet alertSet={template} key={template.title} />
          </div>
        ))}
        <div
          className={classNames('template', { selected: selectedTemplate === 'custom' })}
          onClick={() => {
            setSelectedTemplate('custom');
          }}
        >
          <div className="alert-set device-widget custom template">
            <header>Custom Alert Set</header>
            <div className="body">
              <p>Create your own custom weather alert sets according your and your group's needs.</p>
              <div className="alerts">
                <div className="alert-description-wrap">
                  <div className="alert-description">
                    <span>
                      Choose a station
                    </span>
                  </div>
                </div>
                <div className="alert-description-wrap">
                  <div className="alert-description">
                    <span>
                      Assign up to 5 alerts in the set
                    </span>
                  </div>
                </div>
                <div className="alert-description-wrap">
                  <div className="alert-description">
                    <span>
                      Set notification time window
                    </span>
                  </div>
                </div>
                <div className="alert-description-wrap">
                  <div className="alert-description">
                    <span>
                      Create time alerts
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedTemplate !== null && (
        <div className='btns'>
          <a className='btn btn-primary' onClick={() => onCreate(selectedTemplate === 'custom' ? customTemplate : templates[selectedTemplate])}>Create alert set</a>
        </div>
      )}
    </div>
  );
};

CreateAlertSet.propTypes = {};
CreateAlertSet.defaultProps = {};

CreateAlertSet.displayName = 'CreateAlertSet'
